// Generated file; do not edit. See https://github.com/stencila/stencila/tree/main/rust/schema-gen

export type ExecutableType =
  | "Article"
  | "Button"
  | "CallArgument"
  | "CallBlock"
  | "CodeChunk"
  | "CodeExecutable"
  | "CodeExpression"
  | "ForBlock"
  | "Form"
  | "IfBlock"
  | "IfBlockClause"
  | "IncludeBlock"
  | "Instruction"
  | "InstructionBlock"
  | "InstructionInline"
  | "Parameter";

export const ExecutableTypeList = [
  "Article",
  "Button",
  "CallArgument",
  "CallBlock",
  "CodeChunk",
  "CodeExecutable",
  "CodeExpression",
  "ForBlock",
  "Form",
  "IfBlock",
  "IfBlockClause",
  "IncludeBlock",
  "Instruction",
  "InstructionBlock",
  "InstructionInline",
  "Parameter",
];
